import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FgiBackEndService } from 'src/app/shared/fgi-back-end.service';
import { ValidacaoScr, SolicitacaoHonraValidacaoArquivoScr, SolicitacaoHonraValidacaoScr } from 'src/app/model/validacao-scr.model';
import { OcorrenciaValidacaoVO } from 'src/app/shared/ocorrencia-validacao.vo';

@Injectable({
  providedIn: 'root'
})
export class ValidacaoScrService extends FgiBackEndService<ValidacaoScr> {

  // @Override
  getNewEntity() {
    // o servico sera apenas para leitura
    return undefined;
  }

  // @Override
  protected getResourceURL(): string {
    return 'front/validacoes-scr';
  }

  // nao tem no BaseEntityService pra fazer override
  getValidacaoScr(id): Observable<ValidacaoScr> {
    return this.http.get(`${this.BASE_URL}/${id}`).pipe(
      catchError((e) => this.handleError(e))) as Observable<ValidacaoScr>;
  }

  // nao tem no BaseEntityService pra fazer override
  getValidacoesScr(params?: any): any {
    console.log(`${this.BASE_URL}`)
    return this.http.get(`${this.BASE_URL}`, {params: params}).pipe(
      catchError((e) => this.handleError(e))) as Observable<Array<ValidacaoScr>>;
  }

  getSolicitacoesHonraValidacaoScr(idValidacaoScr: number, params?: any): any {
    return this.http.get(`${this.BASE_URL}/${idValidacaoScr}/solicitacoes-honra`, {params: params}).pipe(
      catchError((e) => this.handleError(e))) as Observable<Array<SolicitacaoHonraValidacaoScr>>;
  }

  getArquivoScrUtilizadoNaValidacao(idValidacaoShScr: number, idSh: number): any {
    return this.http.get(`${this.BASE_URL}/${idValidacaoShScr}/solicitacao-honra/${idSh}/arquivos-scr`).pipe(
      catchError((e) => this.handleError(e))) as Observable<Array<SolicitacaoHonraValidacaoArquivoScr>>;
  }

  getErrosDeValidacao(idValidacaoShScr: number, idSh: number): any {
    return this.http.get(`${this.BASE_URL}/${idValidacaoShScr}/solicitacao-honra/${idSh}/erros-encontrados`).pipe(
      catchError((e) => this.handleError(e))) as Observable<Array<OcorrenciaValidacaoVO>>;
  }
}
